import { render } from "./ServicesMain.vue?vue&type=template&id=27b9d747&scoped=true"
import script from "./ServicesMain.vue?vue&type=script&lang=js"
export * from "./ServicesMain.vue?vue&type=script&lang=js"

import "./ServicesMain.vue?vue&type=style&index=0&id=27b9d747&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b9d747"]])

export default __exports__